import React from 'react';
import { Button, Form, Input } from 'antd';
import { useDispatch } from 'react-redux';
import { loginUser } from '../stateManagement/actions/auth';
import { Navigate, useLocation } from "react-router-dom";
import Loader from '../components/layout/loader';
import { useAuth } from '../hooks/useAuth';

const LoginForm = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { loading, isAuthenticated, user } = useAuth();

  // Show loader if authentication is in progress
  if (loading) return <Loader />;

  // Redirect if already authenticated
  if (isAuthenticated && user) {
    return <Navigate to={user.subAccount ? '/thd' : '/'} state={{ from: location }} replace />;
  }
  const onFinish = (values) => {
    dispatch(loginUser(values));
    form.resetFields();
  }
  
  return (
    <Form form={form} className="login-form" onFinish={onFinish} layout="vertical">
      <div className="menu-logo--large"/>
      <Form.Item 
        label="Email" 
        name="email" 
        rules={[{type: 'email', required: true, message: 'Please a valid email address'}]}
      >
        <Input />
      </Form.Item>
      <Form.Item 
        label="Password" 
        name="password" 
        rules={[{required: true, message: 'Please add your password'}]}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item wrapperCol={{offset: 8, span: 16}}>
        <Button type="primary" htmlType="submit">Login</Button>
      </Form.Item>
    </Form>
  );
};
export default LoginForm;